module.exports = __webpack_public_path__ + "static/media/icon-sas.de36378c.png";